import { render, staticRenderFns } from "./TsRadio.vue?vue&type=template&id=2982d5ad&"
import script from "./TsRadio.vue?vue&type=script&lang=js&"
export * from "./TsRadio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports